import React from 'react'
import ScoreIndicator from 'components/ScoreIndicator/ScoreIndicator'
import { SimpleWordScore } from 'store/services/Exercise'

import styles from './MasteredWords.module.scss'

type MasteredWordsProps = {
  masteredWords: SimpleWordScore[]
}

function MasteredWords({ masteredWords }: MasteredWordsProps) {
  return (
    <div className={styles.container}>
      {masteredWords.map((item) => (
        <div key={`${item.word}${item.score}`} className={styles.masteredWordRow}>
          <div className={`${styles.word} ${item.word.length > 8 ? styles.long : styles.short}`}>{item.word}</div>

          <ScoreIndicator
            value={item.score}
            sizeInPx={42}
            strokeWidthInPx={7}
            disableAnimation
            fontSize={item.score === 100 ? '13px' : '16px'}
            colorsThresholds={{
              LOW: 50,
              HIGH: 80
            }}
          />
        </div>
      ))}
    </div>
  )
}

export default MasteredWords
